export const BILL_TOKEN_FIELD = 'billToken'
export const VIEW_PORT = 'viewPort'
export const SHOULD_DOWNLOAD_PDF = 'downloadPdf'
export const MAX_RETRY_COUNT = 3
export const RETRY_DELAY_MS = 5000
